<template>
  <v-dialog v-model="showing" width="560" persistent>
    <v-card>
      <v-card-title>{{ item ? 'Редактировать КР' : 'Добавить новый КР' }}</v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-text-field
            v-model="form.name"
            label="Название"
            dense
            outlined
            class="mb-2"
            hint='Например, «Бронхиальная астма»'
            persistent-hint
            :rules="[v => !!String(v || '').trim() || 'Укажите название']"
          />
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                v-model="form.crNumber"
                label="№ КР"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="form.year"
                :items="yearItems"
                label="Год"
                dense
                clearable
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="form.reviewBy"
                :items="yearItems"
                label="Пересмотр не позднее"
                dense
                clearable
                hide-details
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="save">Сохранить</v-btn>
        <v-btn text @click="close">Закрыть</v-btn>
        <v-spacer />
        <v-btn v-if="item" color="error" text @click="remove">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  DEFAULT_SUMMARY_CR_ITEM,
  crYearItems,
} from '@/components/expSummary/summaryCrPresence/crPresenceConst'

export default {
  name: 'CrItemDialog',
  props: {
    dialogShow: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  data: () => ({
    form: DEFAULT_SUMMARY_CR_ITEM(),
  }),
  computed: {
    showing: {
      get() {
        return this.dialogShow
      },
      set(v) {
        if (!v) this.$emit('close')
      },
    },
    yearItems() {
      return crYearItems(this.form.year || this.form.reviewBy)
    },
  },
  watch: {
    dialogShow(v) {
      if (v) this.initForm()
    },
  },
  methods: {
    initForm() {
      this.form = this.item
        ? { ...this.item }
        : { ...DEFAULT_SUMMARY_CR_ITEM() }
    },
    close() {
      this.$emit('close')
    },
    save() {
      if (!this.$refs.form.validate()) return
      this.$emit('save', { ...this.form })
      this.close()
    },
    remove() {
      this.$emit('remove')
      this.close()
    },
  },
}
</script>
